import { useCallback, useContext } from 'react';
import InventoryContext from '~/context/srp/InventoryContext';

export default function useSearchAnalyzeTrigger(): () => void {
  const { setSearchAnalyzeTrigger } = useContext(InventoryContext);

  return useCallback(() => {
    setSearchAnalyzeTrigger(true);
  }, [setSearchAnalyzeTrigger]);
}
